import React from 'react';

const Process = () => {
  return (
    <section className="py-24 md:py-32 px-4 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Comment ça se passe ?</h2>
          <p className="text-lg text-gray-600">Un processus simple et transparent pour ta réparation</p>
        </div>

        <div className="grid md:grid-cols-4 gap-8">
          <div className="text-center">
            <div className="w-16 h-16 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-6">1</div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">Contact</h3>
            <p className="text-gray-600">
              Appelez-nous ou prenez rendez-vous en ligne. Décrivez votre problème, nous vous donnons une estimation.
            </p>
          </div>

          <div className="text-center">
            <div className="w-16 h-16 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-6">2</div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">Rendez-vous</h3>
            <p className="text-gray-600">
              Venez à l'atelier à Saint-Chamond ou nous nous déplaçons à votre adresse.
            </p>
          </div>

          <div className="text-center">
            <div className="w-16 h-16 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-6">3</div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">Réparation</h3>
            <p className="text-gray-600">
              Nous réparons votre téléphone avec des pièces Premium testées. La plupart des réparations sont faites le jour même.
            </p>
          </div>

          <div className="text-center">
            <div className="w-16 h-16 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-6">4</div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">C'est réparé !</h3>
            <p className="text-gray-600">
              Nous testons toutes les fonctionnalités avec vous. Vous repartez avec votre téléphone réparé et une garantie 3 mois.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;